<template>
    <div class="userManagerWrap">
        <div class="mainContent">
            <div class="searchBox">
            	<div class="left">
            		<el-form :inline="true">
            			</el-form-item>
            			<el-form-item>
            				<el-input class="fuzzyInput" placeholder="手机号/真实姓名" v-model="formObj.fuzzyQuery" clearable></el-input>
            			</el-form-item>
            			<el-form-item>
            				<el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
            			</el-form-item>
            		</el-form>
            	</div>
                 <div class="actionBox left">
                    <el-button @click="openAddUserModal" type="primary" v-if="functionAddUser">添加用户 <i class="el-icon-circle-plus-outline"></i> </el-button>
                </div>
            	<div class="right">
            		<el-form :inline="true">
            			<el-form-item>
            				<el-select placeholder="所属角色" v-model="formObj.roleId"  @change="multiSearchClick">
            					<el-option label="全部角色" value=""></el-option>
            					<el-option :label="list.text" :value="list.value" v-for="(list,index) in roleOptionWord" :key="index"></el-option>
            				</el-select>
            			</el-form-item>
            		</el-form>
            	</div>
            </div>
            <el-table :data="userTableData"  style="width: 100%">
              <el-table-column  prop="admin_realname"  label="真实姓名" > </el-table-column>
              <el-table-column  prop="role_name"  label="角色名称" > </el-table-column>
              <el-table-column  prop="admin_cellphone"  label="账号/手机号" > </el-table-column>
              <el-table-column  prop="admin_id"  label="id"  width="30"> </el-table-column>
              <!-- <el-table-column  prop="admin_passwd"  label="密码"  width="180"> </el-table-column> -->
              <el-table-column  prop="admin_position"  label="职位"  > </el-table-column>
             <el-table-column   prop="admin_status" label="状态(筛选)"   width="100"
                    :filters="[{ text: '有效', value: 'y' }, { text: '无效', value: 'n' }]"    :filter-multiple="false"
                    :filter-method="filterTag"                    filter-placement="bottom-end"
                >
                  <template slot-scope="scope">
                       <span v-if="scope.row.admin_status=='y'" class="green">有效</span>
                       <span v-if="scope.row.admin_status=='n'"  class="red">无效</span>
                  </template>  
              </el-table-column>
              <!-- <el-table-column  prop="admin_type"  label="用户类型"   > </el-table-column> -->
              <el-table-column   label="创建时间"   >
                <template slot-scope="scope">
                  {{scope.row.admin_create_time}}
                </template>  
              </el-table-column>
              <el-table-column  label="上次登录时间"  >
                <template slot-scope="scope">
                    {{scope.row.admin_last_login_time}}
                    <!-- {{scope.row.admin_last_login_time.slice(0,16).replace("T",' -')}} -->
                </template>  
              </el-table-column>
              <el-table-column  prop="admin_company_name"  label="公司名称"  > </el-table-column>
              <el-table-column  prop="admin_login_failed_times"  label="错误登录次数(5次将禁止登录)"  >
                   <template slot-scope="scope">
                       <div >
                           {{scope.row.admin_login_failed_times}}
                           <span class="spanBtn" v-if="scope.row.admin_login_failed_times>=5&&functionClearLoginErrorNumber" @click="resetErrorSubmitNum(scope.row)">重置</span>
                       </div>
                      
                   </template>
               </el-table-column>
               <el-table-column                             label="操作" width="170">         
                    <template slot-scope="scope">
                          <el-button size="mini" type="primary" plain @click="openEditUserModal(scope.row)" v-if="scope.row.admin_status=='y'&&functionEditUser">编辑</el-button>
                          <el-button size="mini" type="danger"  plain @click="deleteUser(scope.row)" v-if="scope.row.admin_status=='y'&&functionDeleteUser">删除</el-button>
                           <el-button size="mini" type="success" plain  @click="changeStatus(scope.row,'y')" v-if="scope.row.admin_status=='n'">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pageBox">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                    :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                    background>
                </el-pagination>
            </div>
        </div>
        <el-dialog title="添加用户" :visible.sync="isShowAddUserModal" width="40%" > 
            <div class="modalContent">
                <el-form ref="addUserForm" :model="addUserArg" label-width="120px">
                    <el-form-item label="账号/手机号" required prop='adminCellphone'>
                        <el-input v-model="addUserArg.adminCellphone"></el-input>
                    </el-form-item>
                    <el-form-item label="" >
                        <el-button type="primary" @click="checkPhoneIsExist">检测账号是否已存在</el-button>
                    </el-form-item>
                    <el-form-item label="所属角色" required prop='roleId' >
                        <el-select v-model="addUserArg.roleId" placeholder="请选择角色">
                          <el-option :label="roleOption.text" :value="roleOption.value" v-for="(roleOption,index) in roleOptionWord" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="密码" required prop='adminPasswd' v-if="isHaveThisUser=='n'">
                        <el-input v-model="addUserArg.adminPasswd"></el-input>
                    </el-form-item>
                    <el-form-item label="真实姓名" required prop='adminRealname' v-if="isHaveThisUser=='n'">
                        <el-input v-model="addUserArg.adminRealname"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称" required prop='adminCompanyName' v-if="isHaveThisUser=='n'">
                        <el-input v-model="addUserArg.adminCompanyName"></el-input>
                    </el-form-item>
                    <el-form-item label="职位" required prop='adminPosition' v-if="isHaveThisUser=='n'">
                        <el-input v-model="addUserArg.adminPosition"></el-input>
                    </el-form-item>
                </el-form>
            </div> 
            <span slot="footer" class="dialog-footer" v-if="isHaveThisUser=='n'||isHaveThisUser=='y'">
                    <el-button @click="closeAddUserModal">取 消</el-button>
                    <el-button type="primary" @click="submitAddUserModal('addUserForm')">确 定</el-button>
            </span>
        </el-dialog>
        
        <el-dialog title="编辑用户" :visible.sync="isShowEditUserModal" width="40%" > 
            <div class="modalContent">
                <el-form ref="addEditForm" :model="currentUserObj" label-width="100px">
                    <el-form-item label="adminId"  prop='adminId'>
                        <el-input v-model="currentUserObj.adminId" disabled="disabled"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="账号/手机号"  prop='phone' >
                        <el-input v-model="currentUserObj.phone" disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="所属角色" required prop='roleId'>
                        <el-select v-model="currentUserObj.roleId" placeholder="请选择角色">
                          <el-option :label="roleOption.text" :value="roleOption.value" v-for="(roleOption,index) in roleOptionWord" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                     
                    <el-form-item label="真实姓名" required prop='adminRealname'>
                        <el-input v-model="currentUserObj.adminRealname"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称" required prop='adminCompanyName'>
                        <el-input v-model="currentUserObj.adminCompanyName"></el-input>
                    </el-form-item>
                    <el-form-item label="职位" required prop='adminPosition'>
                        <el-input v-model="currentUserObj.adminPosition"></el-input>
                    </el-form-item>
                     <el-form-item label="新密码"  prop='adminPasswd'>
                        <el-input v-model="currentUserObj.adminPasswd" placeholder="输入新密码"></el-input>
                    </el-form-item>
                </el-form>
            </div> 
            <span slot="footer" class="dialog-footer">
                    <el-button @click="closeEditUserModal">取 消</el-button>
                    <el-button type="primary" @click="submitEditUserModal('addEditForm')">确 定</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
    import {json,wordData,utils} from '@/common/common.js'
    import {ajaxLogin, api} from '@/common/request.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                searchObj:{
                    page:1,
                    num:10,
                    fuzzyQuery:'',
                    roleId:'',
                },
                formObj:{
                	fuzzyQuery:'',
                	roleId:'',
                },
                total:0,
                addUserArg:{},
                isShowAddUserModal:false,
                isShowEditUserModal:false,
                userTableData:[],
                currentUserObj:{},
                roleOptionWord:[],
                isHaveThisUser:'',
            }
        },
        computed: {
            functionClearLoginErrorNumber(){
                // return utils.getCurrentFunction().indexOf("clearLoginErrorNumber")>-1
                return true
            },
            functionAddUser(){
                // return utils.getCurrentFunction().indexOf("user_addUser")>-1
                return true
            },
            functionEditUser(){
                // return utils.getCurrentFunction().indexOf("user_editUser")>-1
                return true
            },
            functionDeleteUser(){
                // return utils.getCurrentFunction().indexOf("user_deleteUser")>-1
                return true
            },
            adminId() {
                return utils.getAdminId()
            },
            roleId() {
                return utils.getRoleId()
            },
           currentPageId(){//当前页面id
              // let currentPath=this.$route.path
              // let result=utils.getCurrentPageId(currentPath)
              // return result
           },
        },
        methods: {
            resetErrorSubmitNum(list){
                let _this=this
              if(confirm("确认重置 ' "+list.admin_realname+" ' 的错误登录次数为 0 吗？")){
                  let arg={
                       "createAdminId":_this.adminId,
                       "adminId":list.admin_id
                  }
                  ajaxLogin('/admin/user/updateUserLoginFailedTimes',arg).then(function(res){
                      if(res.errorCode==200){
                           _this.$message({
                               message: "重置成功", 
                               type: 'success',
                               duration: 1000,
                          }); 
                          _this.refreshPage()
                      }
                  },function(res){
                  })
              }  
            },
            filterTag(value, row) {
                return row.admin_status == value;
            },
            changeStatus(list,status){
                let _this=this
                
                let arg={
                     "createAdminId":_this.adminId,
                     "adminId":list.admin_id,
                     "adminStatus":status,
                     "sysId":utils.getSysId()
                }
                ajaxLogin('/admin/user/editUserStatusByAid',arg).then(function(res){
                    if(res.errorCode==200){
                         _this.$message({
                             message: "启用账号成功", 
                             type: 'success',
                             duration: 1000,
                        }); 
                        _this.refreshPage()
                    }
                },function(res){
                })
            },
            fuzzySearchClick(){
                    this.searchObj={
                        fuzzyQuery:this.formObj.fuzzyQuery,
                        num:this.searchObj.num,
                        page:1,
                    }
                    this.getUserLists()
            },
            multiSearchClick(){
                    this.searchObj={
                        roleId:this.formObj.roleId,
                        num:this.searchObj.num,
                        page:1,
                    }
                    this.getUserLists()
            },
            handleSizeChange(size){//分页：每页n条
            	this.searchObj.num=size
            	this.searchObj.page=1
            	this.getUserLists()
            },
            handleCurrentChange(page){//分页：改变第n页
            	this.searchObj.page=page
            	this.getUserLists()
            },
            refreshPage(){
                this.getUserLists() 
            },
            
            getUserLists(){
                let _this=this
                let arg=this.searchObj
                arg.sysId=utils.getSysId()
                ajaxLogin('/admin/user/getUserList',arg).then(function(res){
                    if(res.errorCode==200){
                        _this.userTableData=[]
                        if(res.data&&res.data.userAuthList){
                        	_this.total=res.data.queryTotalCount
                        	_this.userTableData=res.data.userAuthList
                        }
                    }
                },function(res){
                })
            },
            deleteUser(list){
                let _this=this
                if(!confirm("确认删除 ' "+ list.admin_cellphone + " ' 吗？")){
                    return false
                }
                let arg={
                   adminId:list.admin_id,
                   createAdminId:this.adminId,
                   sysId:utils.getSysId()
                }
                ajaxLogin('/admin//user/delUser',arg).then(function(res){
                    if(res.errorCode==200){
                        _this.$message({
                             message: "删除成功", 
                             type: 'success',
                             duration: 1000,
                        }); 
                        _this.refreshPage()
                    }else{
                         _this.$message({
                             message: res.errorMsg, 
                             type: 'error',
                        }); 
                    }
                },function(res){
                })
            },
            openEditUserModal(list){
                let _this=this
                this.isShowEditUserModal=true
                console.log(list)
                this.currentUserObj={
                    "createAdminId":_this.adminId,
                    "phone":list.admin_cellphone,
                    "adminPasswd":'',
                    "adminRealname":list.admin_realname,
                    "adminCompanyName":list.admin_company_name,
                    "adminPosition":list.admin_position,
                    "adminId":list.admin_id,
                    'roleId':list.role_id
                }
            },
            submitEditUserModal(formName){
                let _this=this
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        let arg=JSON.parse(JSON.stringify(_this.currentUserObj))
                        arg.createAdminId=_this.adminId
                        arg.sysId=utils.getSysId()
                        ajaxLogin('/admin/user/editUserInfo',arg).then(function(res){
                            if(res.errorCode==200){
                                _this.$message({
                                     message: "修改成功", 
                                     type: 'success',
                                     duration: 1000
                                }); 
                                _this.closeEditUserModal()
                                _this.refreshPage()
                            }else{
                                 _this.$message({
                                     message: res.errorMsg, 
                                     type: 'error',
                                }); 
                            }
                        },function(res){
                            
                        })
                    }
                })
            },
            checkPhoneIsExist(){
                let _this=this
                if(!_this.addUserArg.adminCellphone){
                   alert("您还没输入手机号") 
                   return false
                }
                let arg={
                    "adminCellphone":_this.addUserArg.adminCellphone
                }
                ajaxLogin('/admin/user/checkPhone',arg).then(function(res){
                    if(res.errorCode==200){
                       _this.isHaveThisUser=res.data.register
                    }else{
                        _this.$message({
                             message: res.errorMsg, 
                             type: 'error',
                        }); 
                    }
                },function(res){
                })
            },
            submitAddUserModal(formName){
                let _this=this
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        let arg=JSON.parse(JSON.stringify(_this.addUserArg))
                        arg.createAdminId=_this.adminId
                        arg.sysId=utils.getSysId()
                        ajaxLogin('/admin/user/addUser',arg).then(function(res){
                            if(res.errorCode==200){
                                _this.$message({
                                     message: "新增成功", 
                                     type: 'success',
                                     duration: 1000
                                }); 
                                _this.closeAddUserModal()
                                _this.refreshPage()
                            }else{
                                 _this.$message({
                                     message: res.errorMsg, 
                                     type: 'error',
                                }); 
                            }
                        },function(res){
                            
                        })
                    }
                })
            },
            openAddUserModal(){
                this.isShowAddUserModal=true
            },
            closeEditUserModal(){
                this.isShowEditUserModal=false
            },
            closeAddUserModal(){
                 this.isShowAddUserModal=false
                 this.addUserArg={}
            },
            getRoleOption(){
                let _this=this
                let arg={
                    roleSysId:utils.getSysId()
                }
                ajaxLogin('/admin/role/roleList',arg).then(function(res){
                    _this.roleOptionWord=res.data.map(function(item,index){
                        let buffer={
                            text:item.role_name,
                            value:item.role_id
                        }
                        return buffer
                    })
                },function(res){
                })
            }
        },
        mounted() {
            this.getRoleOption()
            this.getUserLists()
        }
    }
</script>

<style scoped lang="scss">
    // *{outline:1px solid red}
    .userManagerWrap{
        .mainContent{
            padding:0 10px;
        }
        .actionBox{padding:0px 0 5px 10px}
        .modalContent{
            
        }
        .searchBox {
            padding-top:10px;
        	.left {
        		float: left;
                .fuzzyInput{width: 300px;}
        	}
        
        	.right {
        		float: right;
        	}
        }
        .searchBox:after{content: "";display: block;clear: both;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/userManager.vue